//import { injectable, inject } from 'inversify'
//import "reflect-metadata";
const fetch = require('isomorphic-fetch');
import * as base64 from 'base-64';
import { SuperDataSvc } from './superdatasvc';
function toWebStandardHeaderCase(s) {
    var out = "";
    if (s.length > 0) {
        out += s[0].toUpperCase();
    }
    for (var i = 1; i < s.length; i++) {
        if (s[i] == "-") {
            out += "-";
            i++;
            out += s[i].toUpperCase();
        }
        else {
            out += s[i];
        }
    }
    return out;
}
//@injectable()
export class HTTPDataSvc extends SuperDataSvc {
    constructor(credsVal) {
        super();
        this.globalHeaders = {};
        this.baseUrl = null;
        if (typeof (credsVal) == "string") {
            this.setBaseUrl(credsVal);
        }
        else if (typeof (credsVal) == "object") {
            var creds = credsVal;
            this.setBaseUrl(creds.baseUrl);
            if (creds.globalHeaders) {
                var headerKeys = Object.keys(creds.globalHeaders);
                for (var i = 0; i < headerKeys.length; i++) {
                    var headerKey = headerKeys[i];
                    var headerVal = creds.globalHeaders[headerKey];
                    this.setGlobalHeader(headerKey, headerVal);
                }
            }
            if (creds.username && creds.password) {
                var authData = base64.encode(creds.username + ':' + creds.password); //base64.encode("user:password")
                this.setGlobalHeader("Authorization", "Basic " + authData);
            }
        }
    }
    setBaseUrl(baseUrl) {
        this.baseUrl = baseUrl;
    }
    setGlobalHeader(name, val) {
        this.globalHeaders[name] = val; //"Authorization": "Basic "
    }
    prepareRequest(url, method, headers, data) {
        if (headers == null)
            headers = {};
        if (this.globalHeaders) {
            var globalHeaderKeys = Object.keys(this.globalHeaders);
            for (var k = 0; k < globalHeaderKeys.length; k++) {
                headers[k] = this.globalHeaders[globalHeaderKeys[k]];
            }
        }
        var body = data;
        if (data) {
            switch (typeof (data)) {
                case "string":
                    if (headers['Content-Type'] == null) {
                        headers['Content-Type'] = "text/plain";
                    }
                    body = data;
                    break;
                case "object":
                    if (data instanceof ArrayBuffer || data instanceof Buffer) {
                        body = data;
                        if (headers['Content-Type'] == null) {
                            headers['Content-Type'] = 'application/octet-stream';
                        }
                        break;
                    }
                default:
                    if (headers['Content-Type'] == null) {
                        headers['Content-Type'] = 'application/json';
                    }
                    try {
                        body = JSON.stringify(data);
                    }
                    catch (e) {
                        return null;
                    }
                    break;
            }
        }
        var reqInit = {
            method: method,
            url: ((this.baseUrl && url[0] == "/") ? this.baseUrl : "") + url,
            //mode: 'cors',
            rejectUnauthorized: false,
            requestCert: true,
            agent: false
            //timeout: 120000, //15000            
        };
        if (headers != null) {
            reqInit.headers = new Headers(headers);
        }
        if (body)
            reqInit.body = body; //whatwg_fetch
        var req = new Request(reqInit.url, reqInit);
        return req;
    }
    getTextByPath(path, baseUrl, headers) {
        var pathSplit = path.split("/");
        if (pathSplit.length < 3)
            return null;
        let [db, table, id] = pathSplit;
        return this.getText(db, table, id, undefined, baseUrl, headers);
    }
    async getText(db, table, id, args, baseUrl, headers) {
        var path = baseUrl ? baseUrl : this.baseUrl;
        path += "/data/" + db + "/" + table + "/";
        if (id)
            path += id; // path+= id+"."+table+".json";
        if (args != null)
            path += "?" + args;
        var rq = this.prepareRequest(path, "GET", headers);
        //console.log("fetching "+path+ " at "+new Date().getTime());
        return fetch(rq).then(function (r) {
            return r.text().then(function (str) {
                //console.log("got response for "+path+ " at "+new Date().getTime());
                return str;
            });
        }).catch(function () {
            throw Error("error fetching " + path + " at " + new Date().getTime());
        });
    }
    getJson(db, table, id, args, baseUrl, headers) {
        return this.getText(db, table, id, args, baseUrl, headers).then(function (str) {
            try {
                var json = JSON.parse(str);
                return json;
            }
            catch (e) {
                throw new Error("Couldnt deseiralize JSON in getJson");
            }
        }, function (reason) {
            throw new Error(reason);
        });
    }
    getDataByPath(url, headers, responseInfo) {
        var rq = this.prepareRequest(url, "GET", headers);
        //rq.headers._headers.authorization = headers.authorization;
        return fetch(rq).then(function (r) {
            var contentType = r.headers.has('content-type') ? r.headers.get('content-type').split(";")[0] : "text/plain";
            if (responseInfo != null) {
                responseInfo.headers = {};
                r.headers.forEach(function (value, key, parent) {
                    responseInfo.headers[toWebStandardHeaderCase(key)] = value;
                });
                responseInfo.status = r.status;
                responseInfo.statusText = r.statusText;
            }
            if (!(r.status >= 200 && r.status < 300)) {
                return null;
            }
            switch (contentType) {
                case "application/json":
                    return r.json().then(function (json) {
                        return json;
                    });
                case "application/octet-stream":
                    return r.blob().then(function (blob) {
                        return blob;
                    });
                case "text/plain":
                case "text/html":
                default:
                    return r.text().then(function (text) {
                        return text;
                    });
            }
        }).catch(function (e) {
            throw Error("error fetching " + url + " at " + new Date().getTime() + " exception " + e);
        });
    }
    putText(db, table, id, data, args, baseUrl, headers) {
        var path = baseUrl ? baseUrl : this.baseUrl;
        path += "/data/" + db + "/" + table + "/";
        if (id)
            path += id; //path+= id+"."+table+".json";
        if (args)
            path += "?" + args;
        var rq = this.prepareRequest(path, "PUT", headers, data);
        return fetch(rq).then(function (r) {
            return (r.status >= 200 && r.status < 300);
        }, function (reason) {
            throw new Error(reason);
        });
    }
    putJson(db, table, id, data, args, baseUrl, headers) {
        var path = baseUrl ? baseUrl : this.baseUrl;
        path += "/data/" + db + "/" + table + "/";
        if (id)
            path += id + "." + table + ".json";
        if (args)
            path += "?" + args;
        var rq = this.prepareRequest(path, "PUT", headers, data);
        return fetch(rq).then(function (r) {
            return (r.status >= 200 && r.status < 300);
        }, function (reason) {
            throw new Error(reason);
        });
    }
    putDataByPath(url, data, headers) {
        var rq = this.prepareRequest(url, "PUT", headers, data);
        return fetch(rq).then(function (r) {
            if (r.status >= 200 && r.status < 300) {
                switch (r.headers.get("content-type").split(",")[0].trim()) {
                    case "application/json":
                        return r.json();
                    default:
                        return r.text();
                }
            }
            else {
                throw new Error("POST response - status code: " + r.status);
            }
        }, function (reason) {
            throw new Error(reason);
        });
    }
    putBuffer(db, table, id, data, args, baseUrl, headers) {
        var path = baseUrl ? baseUrl : this.baseUrl;
        path += "/data/" + db + "/" + table + "/";
        if (id)
            path += id; //path+= id+"."+table+".json";
        if (args)
            path += "?" + args;
        var rq = this.prepareRequest(path, "PUT", headers, data);
        return fetch(rq).then(function (r) {
            return (r.status >= 200 && r.status < 300);
        }, function (reason) {
            throw new Error(reason);
        });
    }
    getBuffer(db, table, id, args, baseUrl, headers, responseInfo) {
        var path = baseUrl ? baseUrl : this.baseUrl;
        path += "/data/" + db + "/" + table + "/";
        if (id)
            path += id; // path+= id+"."+table+".json";       
        if (args)
            path += "?" + args;
        var rq = this.prepareRequest(path, "GET", headers);
        console.log("fetching " + path + " at " + new Date().getTime());
        return fetch(rq).then(function (r) {
            if (responseInfo != null) {
                responseInfo.headers = {};
                r.headers.forEach(function (value, key, parent) {
                    responseInfo.headers[toWebStandardHeaderCase(key)] = value;
                });
                responseInfo.status = r.status;
                responseInfo.statusText = r.statusText;
            }
            if (!(r.status >= 200 && r.status < 300))
                return null;
            //FIXME: use r.body for isomorphic compatibility?
            return r.buffer().then(function (buffer) {
                console.log("got response for " + path + " at " + new Date().getTime());
                return buffer;
            });
        }).catch(function (e) {
            console.log(e);
            throw Error("error fetching " + path + " at " + new Date().getTime());
        });
    }
    postJson(db, table, id, data, args, baseUrl, headers) {
        var path = baseUrl ? baseUrl : this.baseUrl;
        path += "/data/" + db + "/" + table + "/";
        if (id)
            path += id + "." + table + ".json";
        if (args)
            path += "?" + args;
        var rq = this.prepareRequest(path, "POST", headers, data);
        return fetch(rq).then(function (r) {
            if (r.status >= 200 && r.status < 300) {
                return r.json().then(function (o) {
                    if (o == null)
                        return null;
                    return o.$id;
                });
                //return r;
            }
            else {
                throw new Error("POST response - status code: " + r.status);
            }
        }, function (reason) {
            throw new Error(reason);
        });
    }
    async postDataByPath(url, data, headers) {
        var rq = this.prepareRequest(url, "POST", headers, data);
        return fetch(rq).then(function (r) {
            if (r.status >= 200 && r.status < 300) {
                switch (r.headers.get("content-type").split(",")[0].trim()) {
                    case "application/json":
                        return r.json();
                    default:
                        return r.text();
                }
            }
            else {
                throw new Error("POST response - status code: " + r.status);
            }
        }, function (reason) {
            throw new Error(reason);
        });
    }
    async deleteAny(db, table, id, baseUrl, headers) {
        var path = baseUrl ? baseUrl : this.baseUrl;
        path += "/data/" + db + "/" + table + "/" + id;
        var rq = this.prepareRequest(path, "DELETE", headers);
        return fetch(rq).then(function (r) {
            return (r.status >= 200 && r.status < 300);
        }, function (reason) {
            throw new Error(reason);
        });
    }
}
//# sourceMappingURL=httpdatasvc.js.map